// @flow
import React from 'react';
import classnames from 'classnames';
import ClientConfig from '../../context/clientConfig';
import HeaderWithLogo from '../../modules/headers/headerWithLogo';
import HeaderWithImage from '../../modules/headers/headerWithImage';
import WBIForm from '../../modules/forms/wbiForm';
import Footer from '../../modules/footer';
import Heading from '../../modules/heading';

const withBasic = (PassedComponent) => {
  const WithBasic = () => (
    <ClientConfig.Consumer>
      {clientConfig => {
        const {
          clientBodyClassNames,
          clientContentClassNames,
          header,
          headerComponent,
          showFooter,
          justifyContent,
        } = clientConfig;
        return (
          <div className={`${clientBodyClassNames || ''} client-body`}>
            {headerComponent}
            {header === 'withLogo' && <HeaderWithLogo />}
            {header === 'withImage' && <HeaderWithImage />}
            {header === 'none' && ''}
            <div
              className={classnames(
                'client-content d-flex flex-row',
                {
                  'justify-content-end': justifyContent === 'end',
                },
                {
                  'justify-content-start': justifyContent === 'start',
                },
                {
                  'justify-content-center': justifyContent === 'center',
                },
              )}
            >
              <main
                className={classnames(
                  'd-flex flex-column',
                  clientContentClassNames,
                )}
              >
                <Heading />
                <WBIForm passedComponent={<PassedComponent />} />
              </main>
            </div>
            {showFooter && <Footer />}
          </div>
        );
      }}
    </ClientConfig.Consumer>
  );
  return WithBasic;
};

export default withBasic;
